type Props = {
  validationError: string | null
}

export function ElementValidationMessage({ validationError }: Props) {
  return (
    <>
      {validationError && (
        <div
          role="alert"
          className="mb-2 whitespace-pre-line rounded-md bg-[#E50A3E]/10 p-2 text-xs font-semibold text-[#E50A3E]"
        >
          {validationError}
        </div>
      )}
    </>
  )
}
